import { apiService, featureFlagTag } from 'store/api';

export const featureFlagService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<Record<string, unknown>, void>({
      query: () => ({
        url: '/feature-flag/list/FRONTEND_DOCUMENT_COLLECTION',
        method: 'GET',
      }),
      providesTags: [featureFlagTag],
    }),
  }),
});
